export const ZOOM_TO_MARKER_TARGET_MAPBOX = 15;
